var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityAlt = function SvgSecurityAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    d: "M35 70q-.612 0-1.138-.087-.525-.088-1.05-.262Q21.002 65.72 14 55.108q-7-10.611-7-22.84V15.761q0-2.184 1.269-3.93a7.2 7.2 0 0 1 3.281-2.534l21-7.86A7.3 7.3 0 0 1 35 1q1.225 0 2.45.437l21 7.86a7.22 7.22 0 0 1 3.281 2.533A6.53 6.53 0 0 1 63 15.76v16.508q0 12.228-7 22.84T37.188 69.651q-.525.174-1.05.262Q35.613 70 35 70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9D43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M23.588 32.519V27.19c0-6.18 5.01-11.19 11.19-11.19v0c6.18 0 11.19 5.01 11.19 11.19v5.329"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M22 32.763a3 3 0 0 0-3 3v10.07a8 8 0 0 0 8 8h15.604a8 8 0 0 0 8-8v-10.07a3 3 0 0 0-3-3zm17.367 8.428c0 1.56-.847 2.922-2.107 3.65v2.671a2.107 2.107 0 0 1-4.214 0v-2.67a4.214 4.214 0 1 1 6.32-3.65",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    fillRule: "evenodd",
    d: "M37.26 44.841a4.214 4.214 0 1 0-4.214 0v2.67a2.107 2.107 0 1 0 4.214 0z",
    clipRule: "evenodd",
    opacity: 0.5
  })));
};
export default SvgSecurityAlt;